import SimpleBackgroundLayout from '../layout/SimpleBackgroundLayout';
import {CustomLoading} from '../components/common/CustomLoading';

export default function Loading() {
  return <SimpleBackgroundLayout>
    <CustomLoading/>
  </SimpleBackgroundLayout>;
}